<div class="button-field">
  <dx-button
    [text]="text"
    icon="fas fa-plus"
    [type]="type"
    stylingMode="contained"
    [elementAttr]="{ class: 'add-button' }"
    (onClick)="handleClick()"
  ></dx-button>
</div>
